import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { black } from 'web-ui-kit/colors';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

function HamburgerToggle(_ref) {
  var isOpen = _ref.isOpen,
      menuId = _ref.menuId,
      onClick = _ref.onClick;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      style: {
        width: '24px',
        height: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    },
    /*#__PURE__*/
    React.createElement(StyledHamburger, {
      "aria-label": "Toggle menu",
      "aria-expanded": isOpen,
      "aria-controls": menuId,
      isOpen: isOpen,
      onClick: onClick
    },
    /*#__PURE__*/
    React.createElement("span", null),
    /*#__PURE__*/
    React.createElement("span", null),
    /*#__PURE__*/
    React.createElement("span", null)))
  );
}

HamburgerToggle.propTypes = {
  /** indicates state of sliding menu controlled by hamburger */
  isOpen: PropTypes.bool.isRequired,

  /** id of menu controlled by toggle */
  menuId: PropTypes.string.isRequired,

  /** fired on click on the hamburger icon */
  onClick: PropTypes.func.isRequired
}; // Styles

var MAIN_WIDTH = '1.25rem';
var StyledHamburger = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  height: 1.100625rem;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  span {\n    width: ", ";\n    height: 0.1875rem;\n\n    background-color: ", ";\n    border-radius: 0.0625rem;\n    transition: all ease 0.3s;\n    position: relative;\n\n    /**\n    update point where the 2 bars cross. If you change MAIN_WIDTH,\n    you may have to move this point\n    */\n    transform-origin: 0.0625rem;\n\n    :first-of-type {\n      transform: ", ";\n    }\n    :nth-child(2) {\n      margin: 0.25rem 0;\n\n      /** hide/show the middle horizontal bar */\n      opacity: ", ";\n    }\n    :nth-child(3) {\n      transform: ", ";\n    }\n  }\n"])), MAIN_WIDTH, MAIN_WIDTH, black, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 'rotate(45deg) scale(1.1)' : 'rotate(0)';
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen ? '0' : '1';
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen ? 'rotate(-45deg) scale(1.1)' : 'rotate(0)';
});
export default HamburgerToggle;